export default function DocumentIcon() {
  return (
    <svg
      viewBox="0 0 53 53"
      height="53"
      width="53"
      preserveAspectRatio="xMidYMid meet"
      class=""
      version="1.1"
      x="0px"
      y="0px"
      enable-background="new 0 0 53 53"
    >
      <g>
        <defs>
          <circle id="document-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
        </defs>
        <clipPath id="document-SVGID_2_"></clipPath>
        <g clip-path="url(#document-SVGID_2_)">
          <path
            fill="#5157AE"
            d="M26.5-1.1C11.9-1.1-1.1,5.6-1.1,27.6h55.2C54,8.6,41.1-1.1,26.5-1.1z"
          ></path>
          <path
            fill="#5F66CD"
            d="M53,26.5H-1.1c0,14.6,13,27.6,27.6,27.6s27.6-13,27.6-27.6C54.1,26.5,53,26.5,53,26.5z"
          ></path>
        </g>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-document"
          d="M29.09 17.09c-.38-.38-.89-.59-1.42-.59H20.5c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H32.5c1.1 0 2-.9 2-2V23.33c0-.53-.21-1.04-.59-1.41l-4.82-4.83zM27.5 22.5V18L33 23.5H28.5c-.55 0-1-.45-1-1z"
        ></path>
      </g>
    </svg>
  );
}
